/**
 * The choices the design doc exposed as authoring props, as constants. Each one
 * is a knob a settings screen would eventually own.
 */

/** Environment badge in the sidebar header, beside the build version. */
export const ENVIRONMENT = 'STAGING'

/** Show RTP / volatility chips on the catalogue cards. */
export const SHOW_META = true

/** `_blank` opens the game beside the launcher, which is what QA wants. */
export const LAUNCH_TARGET: '_blank' | '_self' = '_blank'

/*
 * Currency and language *lists* come from the server's catalog now — these two
 * are preferences, applied only when the fetched list actually contains them.
 */
export const DEFAULT_CURRENCY = 'EUR'

/** RGS-format locale (`readLaunchParams` passes it straight through). */
export const DEFAULT_LANGUAGE = 'en_us'

/** One press each for the three balances worth testing at. */
export const BALANCE_PRESETS = [
  { label: '500', value: '500' },
  { label: '1 000', value: '1000' },
  { label: '10 000', value: '10000' },
] as const

export const DEFAULT_BALANCE = '1000'
